// extracted by mini-css-extract-plugin
export default {"startScreenWrapper":"StartScreen_start-screen-wrapper__SOTeL","logo":"StartScreen_logo__+PstT"};